import { render, staticRenderFns } from "./ExamPointReport.vue?vue&type=template&id=db7007c0&scoped=true&"
import script from "./ExamPointReport.vue?vue&type=script&lang=js&"
export * from "./ExamPointReport.vue?vue&type=script&lang=js&"
import style0 from "./ExamPointReport.vue?vue&type=style&index=0&id=db7007c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7007c0",
  null
  
)

export default component.exports